export default __webpack_public_path__ + "static/media/Insurance.05e1b6c3.svg";